import React from 'react';
import styled from '@emotion/styled';
import Switch from '@material-ui/core/Switch';
import { TextField } from '../../../components/TextField';
import { SelectSearch } from '../../../components/select/SelectSearch';
import MultipleSelectCheckbox from '../../../components/select/MultipleSelectCheckbox';

const CardConfiguracaoUnidade = ({
  title,
  fields,
  configuracaoUnidade,
  onChange,
  disabled,
}) => {
  const renderField = (field) => {
    const { value, label, type, options, optionsSelect, name } = field;

    switch (type) {
      case 'switch':
        return (
          <FieldRow key={value}>
            <FieldLabel>{label}</FieldLabel>
            <Switch
              checked={!!configuracaoUnidade?.[value]}
              onChange={(e) => onChange(value, e.target.checked)}
              color="primary"
              disabled={disabled}
            />
          </FieldRow>
        );

      case 'input':
        return (
          <FieldRow key={name || value}>
            <FieldLabel>{label}</FieldLabel>
            <InputWrapper>
              <TextField
                value={configuracaoUnidade?.[name || value] || ''}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, '');
                  onChange(name || value, val);
                }}
                disabled={disabled}
                size="small"
                type="text"
                inputProps={{ inputMode: 'numeric' }}
              />
            </InputWrapper>
          </FieldRow>
        );

      case 'select':
        return (
          <FieldRow key={value}>
            <FieldLabel>{label}</FieldLabel>
            <SelectWrapper>
              <SelectSearch
                value={optionsSelect?.find(
                  (opt) => opt.value === configuracaoUnidade?.[value]
                )}
                elements={optionsSelect}
                onChange={(selected) => onChange(value, selected?.value ?? null)}
                isClearable
                isDisabled={disabled}
              />
            </SelectWrapper>
          </FieldRow>
        );

      case 'multiSelect': {
        const selectedValues = configuracaoUnidade?.[value] || [];
        const listaOpcoes = options?.map((opt) => ({
          ...opt,
          nome: opt.label,
          checked: selectedValues.includes(opt.value),
        })) || [];

        const quantidadeChecked = listaOpcoes.filter((o) => o.checked).length;

        return (
          <FieldRow key={value}>
            <FieldLabel>{label}</FieldLabel>
            <SelectWrapper>
              <MultipleSelectCheckbox
                listaOpcoes={listaOpcoes}
                quantidadeChecked={
                  quantidadeChecked > 0
                    ? `${quantidadeChecked} selecionado(s)`
                    : null
                }
                changeCheckbox={(item) => {
                  const isSelected = selectedValues.includes(item.value);
                  const newValues = isSelected
                    ? selectedValues.filter((v) => v !== item.value)
                    : [...selectedValues, item.value];
                  onChange(value, newValues);
                }}
                disabled={disabled}
              />
            </SelectWrapper>
          </FieldRow>
        );
      }

      default:
        return (
          <FieldRow key={value}>
            <FieldLabel>{label}</FieldLabel>
            <Switch
              checked={!!configuracaoUnidade?.[value]}
              onChange={(e) => onChange(value, e.target.checked)}
              color="primary"
              disabled={disabled}
            />
          </FieldRow>
        );
    }
  };

  return (
    <Container>
      <Title>{title}</Title>
      <FieldsContainer>{fields.map(renderField)}</FieldsContainer>
    </Container>
  );
};

export default CardConfiguracaoUnidade;

const Container = styled.div`
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
`;

const Title = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
`;

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 36px;
`;

const FieldLabel = styled.span`
  font-size: 13px;
  color: #505050;
  flex: 1;
`;

const InputWrapper = styled.div`
  width: 120px;
`;

const SelectWrapper = styled.div`
  width: 300px;

  & > div {
    width: 100%;
  }
`;
